<template>
  <form @submit.prevent="submit">
    <div class="text_large">{{ i18n.trd_create_buy_order({ value: assets.base }) }}</div>

    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <input-field
          class="md-layout-item field__number"
          v-model.trim="form.quoteAmount"
          :label="i18n.trd_total_sell({ asset: assets.quote })"
          name="order-buy-total"
          type="number"
          step="0.01"
          v-on:focusout.native="roundQuoteAmount(assets.quote)"
          :errorMessage="allowToValidateQuoted && lessThanMinimumQuoted && currentField === 'quoteAmount' ? i18n.trd_validate_minimal_amount({value: getMinimumQuoted}) : ''"

        />
      </div>
    </div>

    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <input-field
          class="md-layout-item field__number"
          v-model.trim="form.price"
          :label="i18n.trd_price_per({ asset: assets.base })"
          name="order-buy-price"
          v-validate="'required'"
          type="number"
          step="0.01"
          v-on:focusout.native="roundPrice(assets.base)"
          :errorMessage="lessThanMinimumPrice && allowToValidatePrice && currentField === 'price'  ? i18n.trd_validate_minimal_price({value: getMinimumPrice}) : ''"
        />
      </div>
    </div>


    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <input-field
          class="md-layout-item"
          :value="roundCurrency(form.amount, assets.base)"
          :label="i18n.trd_will_receive({ value: assets.base })"
          name="order-buy-amount"
          v-validate="'required'"
          type="number"
          :disabled="true"
        />
        <!-- :errorMessage="allowToValidAmount && lessThanMinimumAmount && currentField === 'amount' ? i18n.trd_validate_minimal_amount({value: getMinimumAmount}) : ''" -->
      </div>
    </div>

    <div class="btn-wrap">
      <md-button type="submit" class="btn md-primary"
                 :disabled="isPending || lessThanMinimumAmount || lessThanMinimumPrice">
        {{ i18n.trd_order_buy() }}
      </md-button>
    </div>
  </form>
</template>

<script>
  import InputField from '@com/fields/InputField'
  import FormMixin from '@com/mixins/form.mixin'
  import OrderMakerMixin from '../order-maker.mixin'

  import { confirmAction } from '@js/modals/confirmation_message'
  import { divide, multiply } from '@utils/math.util'
  import { i18n } from '@js/i18n'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  import { mapActions, mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import {ErrorHandler} from '@js/errors/error_handler'

  export default {
    name: 'trade-orders-buy',
    mixins: [FormMixin, OrderMakerMixin, CurrencyRound],
    components: { InputField },
    props: {
      assets: { type: Object, require: true }
    },
    data () {
      return {
        form: {
          price: undefined,
          amount: undefined,
          quoteAmount: undefined
        },
        allowToValidatePrice: false,
        allowToValidateAmount: false,
        allowToValidateQuoted: false,
        i18n,
        minValue: 0.000001,
        currentField: ''
      }
    },
    created () {
    },
    computed: {
      ...mapGetters([
        vuexTypes.factorData
      ]),
      lessThanMinimumAmount () {
        return Number(this.form.amount) < this.getMinimumAmount
      },
      lessThanMinimumQuoted () {
        return Number(this.form.quoteAmount) < this.getMinimumAmount
      },
      lessThanMinimumPrice () {
        return Number(this.form.price) < this.getMinimumPrice
      },
      getMinimumPrice () {
        return this.form.price <= 0 && this.form.amount <= 0 ? this.minValue : divide(this.minValue, this.form.amount)
      },
      getMinimumAmount () {
        return this.form.amount <= 0 && this.form.price <= 0 ? this.minValue : divide(this.minValue, this.form.price)
      },
      getMinimumQuoted () {
        return this.form.quoteAmount <= 0 && this.form.price <= 0 ? this.minValue : multiply(this.minValue, this.form.price)
      }
    },
    methods: {
      ...mapActions({
        updateTwoFactorData: vuexTypes.SET_TWO_FACTOR_STATE
      }),
      roundQuoteAmount (quote) {
        this.form.quoteAmount = this.roundCurrency(this.form.quoteAmount, quote)
      },
      roundPrice (quote) {
        this.form.price = this.roundCurrency(this.form.price, quote)
      },

      getQuoteAmount () {
        this.form.quoteAmount = multiply(this.form.amount, this.form.price)
      },
      getAmount () {
        this.form.amount = divide(this.form.quoteAmount, this.form.price)
      },
      async submit () {
        if (!await this.isValid()) return
        if (!await confirmAction()) return

        try {
          this.allowToValidatePrice = true
          this.allowToValidateAmount = true
          this.allowToValidateQuoted = true
          this.errors.clear()
          this.disable()

          const res = await this.createOrder({
            pair: {
              base: this.assets.base,
              quote: this.assets.quote
            },
            baseAmount: this.form.amount,
            quoteAmount: this.form.quoteAmount,
            price: this.form.price,
            isBuy: true
          })

          if (res) {
            this.resetForm()
          }
        } catch (error) {
          ErrorHandler.processUnexpected(error)
        }

        this.enable()
      },
      resetForm () {
        this.form.price = undefined
        this.form.amount = undefined
        this.form.quoteAmount = undefined
        setTimeout(() => this.changeAllow(), 0)
      },
      changeAllow () {
        this.allowToValidatePrice = false
        this.allowToValidateAmount = false
        this.allowToValidateQuoted = false
      }
    },
    watch: {
      'form.price' (value) {
        // this.getQuoteAmount()
        this.getAmount()
        this.allowToValidatePrice = true
        this.currentField = 'price'
      },
      'form.amount' (value) {
        // this.getQuoteAmount()
        // this.allowToValidateAmount = true
        this.currentField = 'amount'
      },
      'form.quoteAmount' (value) {
        this.getAmount()
        this.allowToValidateQuoted = true
        this.currentField = 'quoteAmount'
        // this.form.quoteAmount = this.roundCurrency(this.form.quoteAmount, this.assets.quote)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/vue/app/trade/index/components/tradeOrders/TradeOrders.BuyOrder.vue